import React, { useEffect, useMemo, useRef, useState } from 'react';

/* ── design tokens ─────────────────────────────────────────────────────── */
const G  = '#3BFF68';   // Premsi green
const B  = '#0A93F5';   // blue
const V  = '#7B5BFF';   // violet
const SF = { fontFamily: "'Sora', sans-serif" };

/* ── shared primitives ──────────────────────────────────────────────────── */
function Box({ bg, children }) {
  return (
    <div style={{ width: '100%', height: '100%', background: bg, overflow: 'hidden', position: 'relative', ...SF }}>
      {children}
    </div>
  );
}

function Bubble({ text, fromMe, color }) {
  const c = color || (fromMe ? G : 'rgba(255,255,255,0.1)');
  return (
    <div style={{
      alignSelf: fromMe ? 'flex-end' : 'flex-start',
      background: c,
      color: fromMe && c === G ? '#000' : fromMe ? '#fff' : 'rgba(255,255,255,0.85)',
      padding: '7px 11px',
      borderRadius: fromMe ? '13px 13px 3px 13px' : '13px 13px 13px 3px',
      fontSize: 11, fontWeight: 500, maxWidth: '82%',
      lineHeight: 1.4, ...SF,
    }}>
      {text}
    </div>
  );
}

/* ── illustrations ──────────────────────────────────────────────────────── */
function IlluSellOffline() {
  return (
    <Box bg="#09090f">
      <div style={{ padding: '17px 15px', display: 'flex', flexDirection: 'column', gap: 9, height: '100%', justifyContent: 'center' }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: 'rgba(59,255,104,0.09)', border: '1px solid rgba(59,255,104,0.22)',
          borderRadius: 10, padding: '8px 11px',
        }}>
          <div style={{ width: 7, height: 7, borderRadius: '50%', background: G, flexShrink: 0 }} />
          <span style={{ fontSize: 10.5, fontWeight: 700, color: G }}>Premsi AI active while you're away</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Bubble text="Hey! Is the photo pack still available?" fromMe={false} />
          <Bubble text="Yes! Grab it here → premsi.co/pack" fromMe={true} color={G} />
          <Bubble text="Just bought it! Love it" fromMe={false} />
        </div>
        <div style={{
          background: 'rgba(59,255,104,0.1)', border: '1px solid rgba(59,255,104,0.25)',
          borderRadius: 12, padding: '10px 13px',
          display: 'flex', gap: 10, alignItems: 'center',
        }}>
          <div style={{ width: 7, height: 7, borderRadius: '50%', background: G, flexShrink: 0 }} />
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: G }}>Sale while offline</div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>$15 · Photo Pack · 2 min ago</div>
          </div>
        </div>
      </div>
    </Box>
  );
}

function IlluAiFanChat() {
  return (
    <Box bg="#09090f">
      <div style={{ padding: '15px', display: 'flex', flexDirection: 'column', gap: 9, height: '100%', justifyContent: 'center' }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2,
          paddingBottom: 10, borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}>
          <div style={{ width: 26, height: 26, borderRadius: '50%', background: V, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
            <svg width="11" height="11" viewBox="0 0 100 100" fill="#fff"><path d="M50 6C55 40 60 45 94 50C60 55 55 60 50 94C45 60 40 55 6 50C40 45 45 40 50 6Z"/></svg>
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 800, color: '#fff' }}>AI Fan Chat</div>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.35)' }}>Replying in your tone</div>
          </div>
          <div style={{ marginLeft: 'auto', fontSize: 9, fontWeight: 800, color: G, background: 'rgba(59,255,104,0.1)', padding: '3px 8px', borderRadius: 999 }}>LIVE</div>
        </div>
        <Bubble text="Love your content!! Do you have a bundle? 😍" fromMe={false} />
        <Bubble text="Omg yes! My Full Bundle is $29 — you get everything" fromMe={true} color={V} />
        <Bubble text="Do you take custom requests?" fromMe={false} />
        <Bubble text="Always! DM me the details and we'll sort it" fromMe={true} color={V} />
        <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.28)', textAlign: 'center', marginTop: 3 }}>
          ✦ AI replied — matched your voice
        </div>
      </div>
    </Box>
  );
}

function IlluSmartUpsells() {
  return (
    <Box bg="#09090f">
      <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: 9, height: '100%', justifyContent: 'center' }}>
        <Bubble text="Thanks for the voice note! That was so good 🔥" fromMe={false} />
        <Bubble text="So glad you loved it!" fromMe={true} color="rgba(255,255,255,0.09)" />
        <div style={{
          background: 'linear-gradient(135deg,#18082e,#2a0f58)',
          border: '1px solid rgba(123,91,255,0.38)',
          borderRadius: 14, padding: '12px 13px',
          display: 'flex', flexDirection: 'column', gap: 6,
        }}>
          <div style={{ fontSize: 9, fontWeight: 900, color: V, letterSpacing: '0.1em' }}>✦ SMART UPSELL</div>
          <div style={{ fontSize: 12.5, fontWeight: 800, color: '#fff' }}>Full Bundle — $29</div>
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', lineHeight: 1.4 }}>
            She spent $12 last week. Bundle is the perfect next step.
          </div>
          <div style={{
            background: V, borderRadius: 9, padding: '8px',
            textAlign: 'center', fontSize: 11.5, fontWeight: 800, color: '#fff', marginTop: 2,
          }}>Send Offer →</div>
        </div>
      </div>
    </Box>
  );
}

function IlluFulfillmentDashboard() {
  return (
    <Box bg="#09090f">
      <div style={{ padding: '17px 15px', display: 'flex', flexDirection: 'column', gap: 9, height: '100%', justifyContent: 'center' }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.35)', marginBottom: 1 }}>✦ AI Fulfillment Dashboard</div>
        <div style={{
          background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)',
          borderRadius: 14, padding: '12px 13px',
          display: 'flex', flexDirection: 'column', gap: 8,
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontSize: 11.5, fontWeight: 800, color: '#fff' }}>Custom Request</div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>from @mike_fan</div>
            </div>
            <div style={{
              background: 'rgba(59,255,104,0.12)', border: '1px solid rgba(59,255,104,0.28)',
              borderRadius: 7, padding: '4px 9px',
              fontSize: 9, fontWeight: 800, color: G,
            }}>✓ $25 Paid</div>
          </div>
          <div style={{ height: 1, background: 'rgba(255,255,255,0.06)' }} />
          {[['Content type', 'Voice note, 3 min'], ['Tone', 'Personal, warm'], ['Due', 'Tomorrow']].map(([k, v]) => (
            <div key={k} style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)' }}>{k}</span>
              <span style={{ fontSize: 10, fontWeight: 700, color: '#fff' }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{
          background: G, borderRadius: 11, padding: '10px',
          textAlign: 'center', fontSize: 12, fontWeight: 900, color: '#000',
        }}>Mark as Delivered</div>
      </div>
    </Box>
  );
}

function IlluAiCreatorCRM() {
  return (
    <Box bg="#09090f">
      <div style={{ padding: '16px', height: '100%', display: 'flex', flexDirection: 'column', gap: 9, justifyContent: 'center' }}>
        <div style={{
          background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)',
          borderRadius: 14, padding: '13px',
          display: 'flex', gap: 11, alignItems: 'center',
        }}>
          <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'linear-gradient(135deg,#7B5BFF,#4A90E2)', flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12.5, fontWeight: 800, color: '#fff' }}>@sarah_k</div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.38)' }}>Top fan · Since Jan 2024</div>
          </div>
          <div style={{
            background: 'rgba(59,255,104,0.1)', border: '1px solid rgba(59,255,104,0.28)',
            borderRadius: 8, padding: '4px 8px',
            fontSize: 9, fontWeight: 800, color: G, flexShrink: 0,
          }}>★ VIP</div>
        </div>
        {[['Total spent', '$312'], ['Last purchase', '3 days ago'], ['Best next offer', 'Bundle $29']].map(([k, v]) => (
          <div key={k} style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            padding: '8px 10px',
            background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.05)',
            borderRadius: 10,
          }}>
            <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.38)' }}>{k}</span>
            <span style={{ fontSize: 11, fontWeight: 700, color: '#fff' }}>{v}</span>
          </div>
        ))}
      </div>
    </Box>
  );
}

function IlluVoice() {
  const bh = [8,13,21,28,25,17,31,27,19,15,23,29,21,13,10,17,25,31,23,17,11,8,13,19];
  return (
    <Box bg="#0d0a1a">
      <div style={{ padding: '19px 15px', height: '100%', display: 'flex', flexDirection: 'column', gap: 12, justifyContent: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#7B5BFF,#4A90E2)', flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: '#fff' }}>Aitana</div>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.38)' }}>AI Influencer</div>
          </div>
          <div style={{ width: 28, height: 28, borderRadius: '50%', background: G, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
            <svg width="12" height="14" viewBox="0 0 12 14" fill="#000"><path d="M6 0a3 3 0 00-3 3v5a3 3 0 006 0V3a3 3 0 00-3-3zm-5 7a5 5 0 0010 0H9a3 3 0 01-6 0H1z"/></svg>
          </div>
        </div>
        <div style={{
          background: 'rgba(255,255,255,0.06)', borderRadius: 14, padding: '11px 13px',
          fontSize: 11, lineHeight: 1.65, color: 'rgba(255,255,255,0.82)',
        }}>
          Hey! Just wanted to check in with my biggest fan, how have you been?
          <span style={{ color: 'rgba(255,255,255,0.3)' }}> I love your support so much.</span>
        </div>
        <div style={{
          background: 'rgba(255,255,255,0.05)', borderRadius: 14, padding: '11px 13px',
          display: 'flex', alignItems: 'center', gap: 12,
        }}>
          <div style={{ width: 28, height: 28, borderRadius: '50%', background: G, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
            <svg width="9" height="11" viewBox="0 0 9 11" fill="#000"><path d="M1 1l7 4.5-7 4.5z"/></svg>
          </div>
          <svg width="118" height="28" viewBox="0 0 118 28">
            {bh.map((h, i) => (
              <rect key={i} x={i * 4.9 + 0.5} y={(28 - h * 0.82) / 2} width={3.2} height={h * 0.82} rx={1.6}
                fill={i < 14 ? G : 'rgba(255,255,255,0.2)'} />
            ))}
          </svg>
          <div style={{ marginLeft: 'auto', fontSize: 9, color: 'rgba(255,255,255,0.35)' }}>0:08</div>
        </div>
      </div>
    </Box>
  );
}

function IlluEarningCoach() {
  const tips = [
    { text: 'Post a $15 voice note tonight', tag: '+$120 est.', color: G },
    { text: 'Message Sarah — last bought 7d ago', tag: 'High intent', color: B },
    { text: 'Add a $9 bundle to your store', tag: 'Easy win', color: V },
  ];
  return (
    <Box bg="#09090f">
      <div style={{ padding: '17px 15px', height: '100%', display: 'flex', flexDirection: 'column', gap: 9, justifyContent: 'center' }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.38)', marginBottom: 1 }}>✦ Today's recommendations</div>
        {tips.map((tip, i) => (
          <div key={i} style={{
            background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: 13, padding: '11px 13px',
            display: 'flex', gap: 10, alignItems: 'flex-start',
          }}>
            <div style={{
              width: 20, height: 20, borderRadius: 6, flexShrink: 0,
              background: tip.color + '20', border: `1px solid ${tip.color}40`,
              display: 'grid', placeItems: 'center',
            }}>
              <svg width="8" height="8" viewBox="0 0 100 100" fill={tip.color}><path d="M50 6C55 40 60 45 94 50C60 55 55 60 50 94C45 60 40 55 6 50C40 45 45 40 50 6Z"/></svg>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#fff', lineHeight: 1.35 }}>{tip.text}</div>
              <div style={{ fontSize: 9, fontWeight: 800, color: tip.color, marginTop: 3 }}>{tip.tag}</div>
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
}

function IlluSellDigital() {
  const items = [
    { icon: '🖼', label: 'Photo Bundle', price: '$12', sub: '48 files' },
    { icon: '🎬', label: 'Video Series', price: '$24', sub: '6 videos' },
    { icon: '📄', label: 'PDF Guide',    price: '$8',  sub: 'Instant'  },
  ];
  return (
    <Box bg="#f5f6f8">
      <div style={{ padding: '18px 16px', display: 'flex', flexDirection: 'column', gap: 9 }}>
        {items.map((it, i) => (
          <div key={i} style={{
            background: '#fff', borderRadius: 13, padding: '11px 13px',
            display: 'flex', alignItems: 'center', gap: 11,
            boxShadow: '0 1px 10px rgba(0,0,0,0.07)',
          }}>
            <div style={{
              width: 40, height: 40, borderRadius: 10, flexShrink: 0,
              background: 'linear-gradient(135deg,#e0efff,#c8e0ff)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
            }}>{it.icon}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 11.5, fontWeight: 800, color: '#111' }}>{it.label}</div>
              <div style={{ fontSize: 10, color: '#aaa', marginTop: 1 }}>{it.sub}</div>
            </div>
            <div style={{
              background: G, color: '#000',
              padding: '5px 11px', borderRadius: 999,
              fontSize: 11.5, fontWeight: 900, flexShrink: 0,
            }}>{it.price}</div>
          </div>
        ))}
        <div style={{
          background: '#111', borderRadius: 13, padding: '11px',
          textAlign: 'center', fontSize: 12, fontWeight: 900, color: '#fff',
        }}>Unlock All Content →</div>
      </div>
    </Box>
  );
}

function IlluNativeMonetizedFeed() {
  return (
    <Box bg={G}>
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '100%', padding: '22px 18px', gap: 14,
      }}>
        <div style={{
          background: '#fff', borderRadius: 16, padding: '16px', width: '100%',
          position: 'relative', overflow: 'hidden',
          boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        }}>
          <div style={{ display: 'flex', gap: 9, alignItems: 'center', marginBottom: 10 }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#111', flexShrink: 0 }} />
            <div>
              <div style={{ fontSize: 11, fontWeight: 800, color: '#111' }}>@creator</div>
              <div style={{ fontSize: 9, color: '#aaa' }}>Just now</div>
            </div>
          </div>
          <div style={{
            fontSize: 11.5, color: '#444', lineHeight: 1.65,
            WebkitMaskImage: 'linear-gradient(to bottom, #000 35%, transparent 100%)',
            maskImage: 'linear-gradient(to bottom, #000 35%, transparent 100%)',
          }}>
            Just dropped something really exciting behind the scenes — a full walkthrough, my tools, and everything I haven't shared anywhere else...
          </div>
          <div style={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            display: 'flex', justifyContent: 'center', padding: '12px',
            background: 'linear-gradient(to top, rgba(255,255,255,0.97) 55%, transparent)',
          }}>
            <div style={{
              background: '#111', color: '#fff',
              padding: '6px 16px', borderRadius: 999,
              fontSize: 11, fontWeight: 800,
            }}>Unlock to read</div>
          </div>
        </div>
        <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(0,0,0,0.5)' }}>
          Convert followers into buyers
        </div>
      </div>
    </Box>
  );
}

function IlluMonetizeFanRelationships() {
  const channels = [
    { label: 'Tips',            value: '$127 received', color: G  },
    { label: 'Subscription',    value: '$9.99 / mo',    color: B  },
    { label: 'Content Sales',   value: '14 purchases',  color: V  },
    { label: 'Custom Requests', value: '3 active',      color: '#FF9B50' },
  ];
  return (
    <Box bg="#09090f">
      <div style={{ padding: '16px', height: '100%', display: 'flex', flexDirection: 'column', gap: 10, justifyContent: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 10, borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#3BFF68,#0A93F5)', flexShrink: 0 }} />
          <div>
            <div style={{ fontSize: 12, fontWeight: 800, color: '#fff' }}>@superfan_alex</div>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.38)' }}>Fan since Mar 2024 · $312 total</div>
          </div>
          <div style={{ marginLeft: 'auto', fontSize: 9, fontWeight: 800, color: G, background: 'rgba(59,255,104,0.1)', padding: '3px 8px', borderRadius: 999 }}>★ VIP</div>
        </div>
        {channels.map((ch, i) => (
          <div key={i} style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: 12, padding: '10px 13px',
            display: 'flex', alignItems: 'center', gap: 11,
          }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', flexShrink: 0, background: ch.color, boxShadow: `0 0 6px ${ch.color}` }} />
            <div style={{ flex: 1, fontSize: 11, fontWeight: 700, color: '#fff' }}>{ch.label}</div>
            <div style={{
              fontSize: 10.5, fontWeight: 800, color: ch.color,
              background: ch.color + '14',
              padding: '3px 10px', borderRadius: 999,
              border: `1px solid ${ch.color}28`,
            }}>{ch.value}</div>
          </div>
        ))}
      </div>
    </Box>
  );
}

function IlluEarnings() {
  const r = 78, circ = 2 * Math.PI * r;
  return (
    <Box bg="#fff">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 6 }}>
        <svg width={210} height={210} viewBox="0 0 210 210">
          <circle cx={105} cy={105} r={r} fill="none" stroke="#ebebeb" strokeWidth={12} />
          <circle cx={105} cy={105} r={r} fill="none" stroke={G} strokeWidth={12}
            strokeDasharray={`${circ * 0.82} ${circ * 0.18}`}
            strokeLinecap="round"
            transform="rotate(-90 105 105)"
          />
          <text x={105} y={97} textAnchor="middle" dominantBaseline="middle"
            fontFamily="'Sora',sans-serif" fontWeight="900" fontSize={30} fill="#111">$4,219</text>
          <text x={105} y={122} textAnchor="middle"
            fontFamily="'Sora',sans-serif" fontWeight="500" fontSize={11} fill="#bbb">Last 30 days</text>
        </svg>
        <div style={{ display: 'flex', gap: 7, flexWrap: 'wrap', justifyContent: 'center', padding: '0 18px' }}>
          {[['Free to start', B], ['Keep 95%', G], ['Instant payout', V]].map(([l, c]) => (
            <div key={l} style={{ padding: '4px 10px', borderRadius: 999, background: c + '18', border: `1px solid ${c}44`, fontSize: 10, fontWeight: 700, color: c }}>{l}</div>
          ))}
        </div>
      </div>
    </Box>
  );
}

function IlluFastProtectedCheckout() {
  return (
    <Box bg="#f5f6f8">
      <div style={{ padding: '17px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{
          background: 'linear-gradient(135deg,#0A93F5,#0050cc)',
          borderRadius: 14, height: 86, position: 'relative', overflow: 'hidden',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{
            position: 'absolute', inset: 0, display: 'flex', alignItems: 'center',
            justifyContent: 'center', transform: 'rotate(-18deg)',
            fontSize: 10, fontWeight: 900, color: 'rgba(255,255,255,0.13)',
            letterSpacing: '0.3em', whiteSpace: 'nowrap', userSelect: 'none',
          }}>WATERMARKED · WATERMARKED · WATERMARKED</div>
          <div style={{
            background: 'rgba(0,0,0,0.38)', backdropFilter: 'blur(6px)',
            borderRadius: 20, padding: '6px 14px',
            display: 'flex', alignItems: 'center', gap: 6,
            border: '1px solid rgba(255,255,255,0.18)',
          }}>
            <svg width="10" height="12" viewBox="0 0 10 12" fill="#fff"><path d="M5 0A2.5 2.5 0 002.5 2.5v1H1a1 1 0 00-1 1v7.5h10V3.5a1 1 0 00-1-1H7.5v-1A2.5 2.5 0 005 0z"/></svg>
            <span style={{ fontSize: 11, fontWeight: 800, color: '#fff' }}>Protected Content</span>
          </div>
        </div>
        <div style={{
          background: '#fff', borderRadius: 13, padding: '11px 13px',
          display: 'flex', alignItems: 'center', gap: 10,
          boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
        }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: '#111' }}>Exclusive Photo Pack</div>
            <div style={{ fontSize: 10, color: '#aaa', marginTop: 2 }}>48 files · Instant access</div>
          </div>
          <div style={{ fontSize: 22, fontWeight: 900, color: '#111' }}>$15</div>
        </div>
        <div style={{
          background: G, borderRadius: 13, padding: '13px',
          textAlign: 'center', fontSize: 13.5, fontWeight: 900, color: '#000',
        }}>Pay $15 Securely →</div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 14 }}>
          {['Guest checkout', 'Watermarked', 'Instant'].map(f => (
            <div key={f} style={{ fontSize: 9, color: '#bbb', fontWeight: 600 }}>✓ {f}</div>
          ))}
        </div>
      </div>
    </Box>
  );
}

function IlluCreatorGrowthTools() {
  const bars = [30, 42, 38, 55, 68, 75, 90];
  const maxBar = 90;
  return (
    <Box bg="#f5f6f8">
      <div style={{ padding: '18px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{ background: '#fff', borderRadius: 14, padding: '12px 14px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)' }}>
          <div style={{ fontSize: 9, fontWeight: 700, color: '#bbb', marginBottom: 6, letterSpacing: '0.08em' }}>YOUR LINK</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ flex: 1, background: '#f5f6f8', borderRadius: 9, padding: '8px 11px', fontSize: 12, fontWeight: 700, color: B }}>premsi.co/yourname</div>
            <div style={{ background: G, borderRadius: 9, padding: '8px 13px', fontSize: 11, fontWeight: 800, color: '#000' }}>Copy</div>
          </div>
        </div>
        <div style={{ background: '#fff', borderRadius: 14, padding: '12px 14px', boxShadow: '0 1px 6px rgba(0,0,0,0.05)' }}>
          <div style={{ fontSize: 9, fontWeight: 700, color: '#bbb', marginBottom: 8, letterSpacing: '0.08em' }}>WEEKLY GROWTH</div>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 40 }}>
            {bars.map((h, i) => (
              <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                <div style={{ borderRadius: '4px 4px 2px 2px', height: `${(h / maxBar) * 38}px`, background: i === bars.length - 1 ? G : G + '55' }} />
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', marginTop: 5 }}>
            {['M','T','W','T','F','S','S'].map((d, i) => (
              <div key={i} style={{ flex: 1, textAlign: 'center', fontSize: 8, color: '#ccc', fontWeight: 700 }}>{d}</div>
            ))}
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
          {[['128', 'Clicks', B], ['34', 'Fans', G], ['$420', 'Earned', V]].map(([v, l, c]) => (
            <div key={l} style={{ background: '#fff', borderRadius: 12, padding: '10px 6px', textAlign: 'center', boxShadow: '0 1px 5px rgba(0,0,0,0.05)' }}>
              <div style={{ fontSize: 16, fontWeight: 900, color: c }}>{v}</div>
              <div style={{ fontSize: 9, color: '#bbb', fontWeight: 600, marginTop: 2 }}>{l}</div>
            </div>
          ))}
        </div>
      </div>
    </Box>
  );
}

function IlluCourses() {
  const lessons = [
    { n: '01', title: 'Introduction', done: true },
    { n: '02', title: 'Your First Product', done: true },
    { n: '03', title: 'Growing Your Audience', done: false },
    { n: '04', title: 'Monetization Strategy', done: false },
  ];
  return (
    <Box bg="#f5f6f8">
      <div style={{ padding: '16px', height: '100%', display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ background: 'linear-gradient(135deg,#0A93F5,#0058cc)', borderRadius: 14, padding: '14px 15px', marginBottom: 3 }}>
          <div style={{ fontSize: 9, fontWeight: 800, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.12em' }}>CREATOR COURSE</div>
          <div style={{ fontSize: 15, fontWeight: 900, color: '#fff', marginTop: 2 }}>Creator Blueprint</div>
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.6)', marginTop: 3 }}>4 lessons · 50% complete</div>
        </div>
        {lessons.map((l) => (
          <div key={l.n} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#fff', borderRadius: 11, padding: '9px 11px', boxShadow: '0 1px 5px rgba(0,0,0,0.05)' }}>
            <div style={{ width: 22, height: 22, borderRadius: '50%', flexShrink: 0, background: l.done ? G : '#eee', display: 'grid', placeItems: 'center', fontSize: 9, fontWeight: 900, color: l.done ? '#000' : '#ccc' }}>{l.done ? '✓' : l.n}</div>
            <div style={{ fontSize: 11, fontWeight: 600, color: l.done ? '#111' : '#bbb', flex: 1 }}>{l.title}</div>
            {!l.done && (
              <svg width="10" height="12" viewBox="0 0 10 12" fill="#ccc">
                <path d="M5 0A2.5 2.5 0 002.5 2.5v1H1a1 1 0 00-1 1v7.5h10V3.5a1 1 0 00-1-1H7.5v-1A2.5 2.5 0 005 0z"/>
              </svg>
            )}
          </div>
        ))}
      </div>
    </Box>
  );
}

function IlluPremiumAudio() {
  const bh = [11,17,27,34,29,21,37,33,25,19,29,37,27,17,13,21,31,39,29,21,15,11,17,25];
  return (
    <Box bg="#09090f">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 13, padding: '20px' }}>
        <div style={{ width: 82, height: 82, borderRadius: 20, flexShrink: 0, background: 'linear-gradient(135deg,#1a082e,#4B29A8)', display: 'grid', placeItems: 'center', boxShadow: '0 8px 28px rgba(123,91,255,0.38)' }}>
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
            <circle cx="13" cy="13" r="12" stroke={V} strokeWidth="1.5" strokeDasharray="3 3" />
            <circle cx="13" cy="13" r="4" fill={V} />
          </svg>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 13, fontWeight: 900, color: '#fff' }}>Private Drop #12</div>
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.38)', marginTop: 2 }}>Subscribers only · 14:22</div>
        </div>
        <svg width="192" height="34" viewBox="0 0 192 34">
          {bh.map((h, i) => (
            <rect key={i} x={i * 8 + 1} y={(34 - h * 0.88) / 2} width={5} height={h * 0.88} rx={2.5}
              fill={i < 10 ? V : 'rgba(255,255,255,0.18)'} />
          ))}
        </svg>
        <div style={{ display: 'flex', gap: 18, alignItems: 'center' }}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="rgba(255,255,255,0.35)"><path d="M0 2v12l6-6-6-6zm7 0v12l9-6-9-6z"/></svg>
          <div style={{ width: 38, height: 38, borderRadius: '50%', background: V, display: 'grid', placeItems: 'center' }}>
            <svg width="12" height="14" viewBox="0 0 12 14" fill="#fff"><path d="M1 1l10 6-10 6z"/></svg>
          </div>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="rgba(255,255,255,0.35)"><path d="M16 2v12l-6-6 6-6zm-7 0v12l-9-6 9-6z"/></svg>
        </div>
      </div>
    </Box>
  );
}

function IlluCreatorAppStore() {
  const nodes = [[145,30],[240,100],[220,210],[70,210],[50,100]];
  return (
    <Box bg="linear-gradient(160deg,#c4d8ff,#deeaff,#eef5ff)">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 12, padding: '20px', position: 'relative' }}>
        <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} viewBox="0 0 290 270" preserveAspectRatio="xMidYMid meet">
          {nodes.map(([x,y],i) => (
            <line key={i} x1={145} y1={135} x2={x} y2={y} stroke="rgba(10,100,245,0.22)" strokeWidth="1.5" strokeDasharray="5 4"/>
          ))}
          {nodes.map(([cx,cy],i) => (
            <circle key={i} cx={cx} cy={cy} r={11} fill="white" stroke="rgba(10,100,245,0.28)" strokeWidth="1.5"/>
          ))}
        </svg>
        <div style={{ width: 88, height: 88, borderRadius: 22, background: 'linear-gradient(140deg,#4a96f8,#1a5ccc)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, boxShadow: '0 12px 36px rgba(10,100,245,0.32)', position: 'relative', zIndex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 900, color: '#fff', letterSpacing: '0.05em' }}>API</div>
          <div style={{ width: 22, height: 22, borderRadius: 7, background: 'rgba(255,255,255,0.22)', display: 'grid', placeItems: 'center' }}>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="#fff">
              <path d="M5 1v8M1 5h8" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
        </div>
        <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(10,50,160,0.55)', position: 'relative', zIndex: 1 }}>
          Creator App Store
        </div>
      </div>
    </Box>
  );
}

/* ── illustration lookup ────────────────────────────────────────────────── */
const FEATURE_ILLUSTRATIONS = {
  'sell-while-offline':             IlluSellOffline,
  'ai-fan-chat':                    IlluAiFanChat,
  'smart-upsells':                  IlluSmartUpsells,
  'ai-fulfillment-dashboard':       IlluFulfillmentDashboard,
  'ai-creator-crm':                 IlluAiCreatorCRM,
  'ai-voice-intimacy':              IlluVoice,
  'ai-earning-coach':               IlluEarningCoach,
  'sell-digital-content-instantly': IlluSellDigital,
  'native-monetized-feed':          IlluNativeMonetizedFeed,
  'monetize-fan-relationships':     IlluMonetizeFanRelationships,
  'creator-first-earnings':         IlluEarnings,
  'fast-protected-checkout':        IlluFastProtectedCheckout,
  'creator-growth-tools':           IlluCreatorGrowthTools,
  'creator-courses':                IlluCourses,
  'premium-audio':                  IlluPremiumAudio,
  'creator-app-store':              IlluCreatorAppStore,
};

/* ── card data (AI first, then platform, then coming soon) ──────────────── */
const featureCards = [
  { id: 'sell-while-offline',             category: 'ai',          tag: 'AI',          heading: 'Sell While Offline',             text: 'Premsi AI chats with fans, understands intent and helps close sales even when creators are not online.' },
  { id: 'ai-fan-chat',                    category: 'ai',          tag: 'AI',          heading: 'AI Fan Chat',                    text: 'Reply to every fan in your tone, keep conversations warm and never miss high-intent messages again.' },
  { id: 'smart-upsells',                  category: 'ai',          tag: 'AI',          heading: 'Smart Upsells',                  text: 'Automatically recommend the right premium message, bundle, tip or membership based on what each fan wants.' },
  { id: 'ai-fulfillment-dashboard',       category: 'ai',          tag: 'AI',          heading: 'AI Fulfillment Dashboard',       text: 'When AI sells a custom request, Premsi turns it into a clear creator task with payment status, fan preferences and delivery details.' },
  { id: 'ai-creator-crm',                 category: 'ai',          tag: 'AI',          heading: 'AI Fan CRM',                     text: 'Track fan spend, preferences, churn risk and purchase intent so creators know who to message and what to sell next.' },
  { id: 'ai-voice-intimacy',              category: 'ai',          tag: 'AI',          heading: 'AI Voice Intimacy',              text: 'Scale personal voice notes and voice-style fan interactions without spending hours in the inbox.' },
  { id: 'ai-earning-coach',               category: 'ai',          tag: 'AI',          heading: 'AI Earning Coach',               text: 'Get simple recommendations on what to post, what to sell, who to message and how to grow revenue.' },
  { id: 'sell-digital-content-instantly', category: 'existing',    tag: null,          heading: 'Sell Digital Content Instantly', text: 'Turn videos, photos, PDFs, templates, private media and digital downloads into paid products fans can unlock instantly.' },
  { id: 'native-monetized-feed',          category: 'existing',    tag: null,          heading: 'Market Through a Social Feed',   text: 'Post free teasers, grow attention and convert followers into paid unlocks without sending them elsewhere.' },
  { id: 'monetize-fan-relationships',     category: 'existing',    tag: null,          heading: 'Monetize Fan Relationships',     text: 'Fans can tip, subscribe, join paid groups, buy private content, message creators and request custom content.' },
  { id: 'creator-first-earnings',         category: 'existing',    tag: null,          heading: 'Creator-First Earnings',         text: 'Start for free, keep most of what you earn and request payouts directly from your account.' },
  { id: 'fast-protected-checkout',        category: 'existing',    tag: null,          heading: 'Fast Protected Checkout',        text: 'Let fans buy in seconds with instant delivery, secure access, previews and watermarks that protect premium content.' },
  { id: 'creator-growth-tools',           category: 'existing',    tag: null,          heading: 'Creator Growth Tools',           text: 'Use shareable links, referrals, social media workflows and campaign tools to turn followers into paying fans.' },
  { id: 'creator-courses',                category: 'coming-soon', tag: 'Coming soon', heading: 'Creator Courses',                text: 'Package your knowledge into paid courses, lessons and step-by-step guides your audience can buy directly.' },
  { id: 'premium-audio',                  category: 'coming-soon', tag: 'Coming soon', heading: 'Premium Audio',                  text: 'Sell private podcasts, voice updates and exclusive audio drops to your most loyal fans.' },
  { id: 'creator-app-store',              category: 'coming-soon', tag: 'Coming soon', heading: 'Creator App Store',              text: 'Connect automations, analytics tools and third-party apps through an open platform built for creators and AI builders.' },
];

/* ── sub-components ─────────────────────────────────────────────────────── */
const SPARKLE_PATH = 'M50 6C55 40 60 45 94 50C60 55 55 60 50 94C45 60 40 55 6 50C40 45 45 40 50 6Z';

function TagSparkle({ className }) {
  return (
    <svg className={className} aria-hidden="true" viewBox="0 0 100 100" fill="currentColor">
      <path d={SPARKLE_PATH} />
    </svg>
  );
}

function FeatureTag({ tag }) {
  if (!tag) {
    return (
      <span className="alt-feature-carousel__tag alt-feature-carousel__tag--spacer" aria-hidden="true">
        &nbsp;
      </span>
    );
  }
  if (tag === 'AI') {
    return (
      <span className="alt-feature-carousel__tag alt-feature-carousel__tag--ai">
        <TagSparkle className="alt-feature-carousel__tag-sparkle alt-feature-carousel__tag-sparkle--lg" />
        <span className="alt-feature-carousel__tag-ai-label">AI</span>
      </span>
    );
  }
  return (
    <span className={`alt-feature-carousel__tag${tag === 'Coming soon' ? ' alt-feature-carousel__tag--coming' : ''}`}>
      {tag}
    </span>
  );
}

/* ── carousel ───────────────────────────────────────────────────────────── */
const AUTO_SCROLL_MS = 5000;

export default function AltFeatureCarouselSectionV2() {
  const cardCount = featureCards.length;
  const [currentIndex, setCurrentIndex] = useState(cardCount);
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const autoScrollRef = useRef(null);
  const viewportRef = useRef(null);
  const [cardWidthPx, setCardWidthPx] = useState(0);

  const trackItems = useMemo(
    () => [...featureCards, ...featureCards, ...featureCards],
    []
  );

  const getCardsPerView = () => {
    if (typeof window === 'undefined') return 4;
    if (window.innerWidth <= 480) return 1;
    if (window.innerWidth <= 768) return 2;
    if (window.innerWidth <= 1100) return 3;
    return 4;
  };

  const updateMetrics = () => {
    const viewport = viewportRef.current;
    if (!viewport) return;
    setCardWidthPx(viewport.clientWidth / getCardsPerView());
  };

  const restartAutoScroll = () => {
    if (autoScrollRef.current) window.clearInterval(autoScrollRef.current);
    autoScrollRef.current = window.setInterval(() => {
      setCurrentIndex((prev) => prev + 1);
      setTransitionEnabled(true);
    }, AUTO_SCROLL_MS);
  };

  const handlePrev = () => { setCurrentIndex((p) => p - 1); setTransitionEnabled(true); restartAutoScroll(); };
  const handleNext = () => { setCurrentIndex((p) => p + 1); setTransitionEnabled(true); restartAutoScroll(); };

  const handleTrackTransitionEnd = () => {
    if (currentIndex >= cardCount * 2) { setTransitionEnabled(false); setCurrentIndex(currentIndex - cardCount); return; }
    if (currentIndex < cardCount)      { setTransitionEnabled(false); setCurrentIndex(currentIndex + cardCount); }
  };

  useEffect(() => {
    restartAutoScroll();
    return () => { if (autoScrollRef.current) window.clearInterval(autoScrollRef.current); };
  }, []);

  useEffect(() => {
    updateMetrics();
    window.addEventListener('resize', updateMetrics);
    return () => window.removeEventListener('resize', updateMetrics);
  }, []);

  useEffect(() => {
    if (transitionEnabled) return;
    const id = window.requestAnimationFrame(() => setTransitionEnabled(true));
    return () => window.cancelAnimationFrame(id);
  }, [transitionEnabled]);

  return (
    <section id="features" className="alt-feature-carousel alt-feature-carousel--v2" aria-labelledby="alt-feature-carousel-v2-title">
      <div className="alt-feature-carousel__container">
        <div className="alt-feature-carousel__heading">
          <h2 id="alt-feature-carousel-v2-title" className="alt-feature-carousel__title">Features</h2>
          <p className="alt-feature-carousel__subtitle">Everything you need</p>
          <p className="alt-feature-carousel__description">One platform. Every tool a creator needs.</p>
        </div>

        <div className="alt-feature-carousel__viewport" ref={viewportRef}>
          <div
            className={`alt-feature-carousel__track${transitionEnabled ? '' : ' alt-feature-carousel__track--no-transition'}`}
            style={{ transform: `translate3d(${-currentIndex * cardWidthPx}px, 0, 0)` }}
            onTransitionEnd={handleTrackTransitionEnd}
          >
            {trackItems.map((feature, index) => {
              const Illu = FEATURE_ILLUSTRATIONS[feature.id];
              return (
                <article
                  className="alt-feature-carousel__card"
                  key={`${feature.id}-${index}`}
                  style={{ flexBasis: `${cardWidthPx}px` }}
                >
                  <div className="alt-feature-carousel__media-wrap">
                    {Illu ? <Illu /> : null}
                  </div>
                  <div className="alt-feature-carousel__content">
                    <FeatureTag tag={feature.tag} />
                    <h3 className="alt-feature-carousel__card-title">{feature.heading}</h3>
                    <p className="alt-feature-carousel__card-body">{feature.text}</p>
                  </div>
                </article>
              ); 
            })}
          </div>
        </div>

        <div className="alt-feature-carousel__controls" aria-label="Feature carousel controls">
          <button type="button" className="alt-feature-carousel__arrow" onClick={handlePrev} aria-label="Previous features">&#8592;</button>
          <button type="button" className="alt-feature-carousel__arrow" onClick={handleNext} aria-label="Next features">&#8594;</button>
        </div>
      </div>
    </section>
  );
}
